import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import { Module } from '@/modules/moduleSubscription/types/module'
import ModuleItemListItem from '@/modules/moduleSubscription/components/list/module-item-list/module-item-list-item'
import { Type } from '@/redux/ducks/subscription/types/details'
import { useAppSelector } from '@/redux/store'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    [theme.devices.mobile]: {
      width: '100%',
    },
  },
  moduleItems: {
    display: 'flex',
    gap: 32,
    [theme.devices.mobile]: {
      flexDirection: 'column',
    },
  },
}))

interface IModuleItemList {
  modules: Module[]
  selectedPeriod: string
}

const ModuleItemList = (props: IModuleItemList) => {
  const classes = useStyles()
  const { modules, selectedPeriod } = props

  const moduleItems = useMemo(() => {
    return modules.map((module) => {
      return <ModuleItemListItem key={module.name} module={module} selectedPeriod={selectedPeriod} />
    })
  }, [modules, selectedPeriod])

  return (
    <div className={classes.root}>
      <div className={classes.moduleItems}>{moduleItems}</div>
    </div>
  )
}

export default ModuleItemList
